/**
 * Class definition for `clover map` element
 *
 * @class CloverMap
 * @extends {HTMLElement}
 */
class CloverMap extends HTMLElement {
	constructor() {
		self = super(self);
		this._zoom = this.getAttribute('zoom') || 15;
		return self;
	}

	/**
	 * Tag name of element
	 *
	 * @readonly
	 * @static
	 */
	static get is() {
		return 'clover-map';
	}

	/**
	 * Returns array of map point elements
	 *
	 * @private
	 * @readonly
	 * @returns {HTMLElement[]} Array of tabs
	 */
	get _points() {
		let list = [...this.children].filter(el => {
			return el.matches('clover-map-point');
		});
		return list;
	}

	/**
	 * Lifecycle event when element is attached to DOM
	 */
	connectedCallback() {
		if (this._points.length === 0) {
			console.warn('Missing map points');
			return;
		}

		// When child elements are defined, setup tabs
		Promise.all([
			customElements.whenDefined('clover-map-point')
		]).then(() => {
			window.initMap = this.initMap.bind(this);
		});
	}

	/**
	 * Create Map Points Array
	 *
	 * @private
	 * @returns {LatLng[]} Array of LatLng objects
	 */
	_createPointsArray() {
		let points = [];

		this._points.forEach(
			(el, index) => {
				points[index] = new google.maps.Marker({
					position: new google.maps.LatLng(el.lat, el.lng),
					title: el.title
				});
			});

		return points;
	}

	/**
	 * Check google.maps object is defined.
	 *
	 * @private
	 */
	// TODO: Change to run when global object is defined rather than rely on callback
	_isGoogleMapsLoaded() {
		const timeout = 6000;
		const start = Date.now();

		return new Promise(waitForGoogle);

		function waitForGoogle(resolve, reject) {
			if (window.google)
				resolve();
			else if (timeout && (Date.now() - start) >= timeout)
				reject(new Error("timeout"));
			else
				setTimeout(waitForGoogle.bind(this, resolve, reject), 50);
		}
	}

	/**
	 * Check google.maps object is defined.
	 *
	 * @private
	 * @param {LatLng[]} LatLng coords array
	 * @returns {LatLng} LatLng object
	 */
	_getCentre(points) {
		// TODO: Calculate centre of points when there's multiple
		return new google.maps.LatLng(-25.344, 131.031);
	}


	/**
 * Set up global map object for when google.maps load
 *
 * @public
 */
	initMap() {
		const pointsArray = this._createPointsArray();

		const defaultCentre = this._getCentre();

		const map = new google.maps.Map(this, {
			zoom: this._zoom,
			center: pointsArray.length === 1 ? pointsArray[0].getPosition() : defaultCentre,
		});

		pointsArray.forEach(
			(point) => {
				point.setMap(map);
			}
		)
	}
}

customElements.define(CloverMap.is, CloverMap);
